export { CommunicationPreference } from './CommunicationPreference';
